module.exports = __webpack_public_path__ + "img/77.114cd16e.png";